
import { Button } from "@/components/ui/button";
import { LogOut, UserPlus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

interface DashboardHeaderProps {
  onSignOut: () => Promise<void>;
  isSuperAdmin: boolean;
}

export const DashboardHeader = ({ onSignOut, isSuperAdmin }: DashboardHeaderProps) => {
  const navigate = useNavigate();
  
  return (
    <div className="flex justify-between items-center">
      <div className="space-y-2">
        <h1 className="text-2xl font-semibold tracking-tight">
          Gruppledarsida
        </h1>
        <p className="text-sm text-muted-foreground">
          Uppdatera din profil och hantera grupper
        </p>
      </div>
      <div className="flex gap-2">
        {isSuperAdmin && (
          <Button variant="outline" onClick={() => navigate("/admin/requests")}>
            <UserPlus className="mr-2 h-4 w-4" />
            Administrativ panel
          </Button>
        )}
        <Button variant="outline" onClick={onSignOut}>
          <LogOut className="mr-2 h-4 w-4" />
          Logga ut
        </Button>
      </div>
    </div>
  );
};
